import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.h.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutHComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
